import type { Member } from "../services/types";

/** Sum of outstanding balances across every group the member belongs to. */
export function totalOutstanding(member: Member): number {
  return member.enrollments.reduce((sum, e) => sum + e.outstanding, 0);
}

/** Number of chit groups the member is enrolled in. */
export function memberGroupCount(member: Member): number {
  return member.enrollments.length;
}

/** Number of payouts (cycles) the member has already won. */
export function payoutCount(member: Member): number {
  return member.enrollments.filter((e) => e.wonCycle != null).length;
}